//—— 分享 util：叫出系統分享選單（Web Share API），不支援則複製連結 ——
//  手機 / App WebView 有 navigator.share → 原生分享選單（LINE / IG / 複製…都有）
//  桌機多半沒有 → fallback 複製連結到剪貼簿
//
//  回傳字串（呼叫端可據此提示）：
//    "shared"    已透過系統選單分享
//    "cancelled" 使用者在系統選單按取消（不算失敗、靜默）
//    "copied"    fallback 已複製連結
//    "failed"    連複製都失敗
export async function shareOrCopy({ title, text, url }) {
  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return "shared";
    } catch (e) {
      //使用者取消分享 → 當作正常、不 fallback
      if (e?.name === "AbortError") return "cancelled";
      //其他錯誤 → 往下走複製 fallback
    }
  }

  //fallback：複製連結
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      return "copied";
    }
  } catch (e) {
    //clipboard 被擋 → 走 textarea fallback
  }
  try {
    const ta = document.createElement("textarea");
    ta.value = url;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok ? "copied" : "failed";
  } catch (e) {
    return "failed";
  }
}
